<template>
<div class="content-page">
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="page-title-box">
                    <h4 class="page-title">마이 페이지</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-4 col-lg-5">
                    <div class="card text-center">
                        <div class="card-body">
                            <img :src="parentUserInfo.image_url" class="rounded-circle avatar-lg img-thumbnail object-fit-cover" alt="profile-image">

                            <h4 class="mb-0 mt-2">{{ parentUserInfo.name }}</h4>
                            <p class="text-muted font-14"></p>

                            <button type="button" class="btn btn-outline-success me-1" @click="openModal('userInfoEdit-modal')">
                                <i class="mdi mdi-wrench"></i> 정보 수정
                            </button>
                            <button type="button" class="btn btn-outline-info" @click="openModal('pwchange-modal')">
                                <i class="mdi mdi-key-change"></i> 비밀번호 변경
                            </button>

                            <div class="text-start mt-3">
                                <p class="text-muted mb-2 font-13">
                                    <strong>이름 : </strong> {{ parentUserInfo.name }}
                                </p>
                                <p class="text-muted mb-2 font-13">
                                    <strong>이메일 : </strong> {{ parentUserInfo.email }}
                                </p>
                                <p class="text-muted mb-2 font-13">
                                    <strong>휴대폰 번호 : </strong> {{ parentUserInfo.phone_no }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-8 col-lg-7">
                    <div class="card">
                        <div class="card-body">
                            <ul class="nav nav-pills bg-nav-pills nav-justified mb-3">
                                <li class="nav-item">
                                    <a href="#inquiry" data-bs-toggle="tab" aria-expanded="true" class="nav-link rounded-0 active">
                                        <i class="mdi mdi-post me-1"></i>문의 내역
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="#adv" data-bs-toggle="tab" aria-expanded="false" class="nav-link rounded-0">
                                        <i class="mdi mdi-advertisements me-1"></i>광고 내역
                                    </a>
                                </li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane show active" id="inquiry">
                                    <label class="form-label">문의하기</label>
                                    <input class="form-control" type="text" id="title" placeholder="문의 제목을 입력해주세요." v-model="inquiry.title" />
                                    <div class="invalid-feedback">
                                        {{ errMsg.email }}
                                    </div>
                                    <div class="border rounded mt-2 mb-4">
                                        <div action="#" class="comment-area-box">
                                            <textarea rows="5" id="content" class="form-control border-0 resize-none" placeholder="문의 내용을 입력해주세요." v-model="inquiry.content"></textarea>
                                            <div class="p-2 bg-light d-flex justify-content-between align-items-center">
                                                <div @click="openUpload()">
                                                    <a class="btn btn-sm px-2 font-16 btn-light"><i class="mdi mdi-camera"></i></a>
                                                    <input type="file" id="inquiryImg" accept="image/*" style="display:none;" multiple @change="selectImage($event)" />
                                                </div>
                                                <button type="submit" class="btn btn-sm btn-info" @click="openConfirmModal()">등록</button>
                                            </div>
                                            <div class="p-2 bg-light" v-if="inquiry.attachments.length > 0">
                                                <span class="image-container" v-for="(image, idx) in inquiry.attachments" :key="`inqury_image_${idx}`">
                                                    <img :src="image.image_url" alt="post-img" class="rounded me-1 mt-1" width="70" height="70" />
                                                    <button class="close-button" @click="deleteImage(idx)">&times;</button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <label class="form-label">문의 내역</label>
                                    <div class="row" v-if="loading"></div>
                                    <template v-else>
                                        <div class="row" v-if="inquiryList.length > 0">
                                            <div class="border border-light rounded p-2 mb-3" v-for="(inquiry, idx) in inquiryList" :key="`inqury_${idx}`">
                                                <div class="d-flex align-items-center">
                                                    <div class="badge p-1 me-1" :class="computedInquiryStatusColor(inquiry)">
                                                        <i class="mdi" :class="computedInquiryStatusIcon(inquiry)"></i> {{ computedInquiryStatusTxt(inquiry) }}
                                                    </div>
                                                    <div class="d-flex align-items-center w-100 ms-1">
                                                        <h5 class="m-0">
                                                            {{ inquiry.title }}
                                                        </h5>
                                                        <button class="delete-button ms-auto" @click="openDelModal(inquiry)">&times;</button>
                                                    </div>
                                                </div>
                                                <p class="text-muted ms-1 mt-1">
                                                    <small>{{ inquiry.created }}</small>
                                                </p>
                                                <p>{{ inquiry.content }}</p>

                                                <template v-if="inquiry.attachments">
                                                    <img :src="image.image_url" alt="post-img" class="rounded me-1 mt-1" width="70" height="70" v-for="(image, idx) in inquiry.attachments" :key="`inqury_images_${idx}`">
                                                </template>
                                                <div class="mx-n2 p-3 mt-3 bg-light" v-if="inquiry.answer">
                                                    <div class="d-flex ms-1">
                                                        <div>
                                                            <h5 class="mt-0">
                                                                {{ inquiry.answer.title }}
                                                                <small class="text-muted">&nbsp;&nbsp;&nbsp;{{ inquiry.answer.created }}</small>
                                                            </h5>
                                                            {{ inquiry.answer.content }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row justify-content-center mt-3" v-else>
                                            <div class="col-xl-10">
                                                <div class="text-center">
                                                    <img src="assets/images/svg/file-searching.svg" height="140" alt="File not found Image">
                                                    <p class="text-muted mt-3">문의 내역이 존재하지 않습니다.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>

                                <div class="tab-pane" id="adv">
                                    <div class="table-responsive">
                                        <table class="table table-borderless table-nowrap table-centered text-center mb-0">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>광고 번호</th>
                                                    <th>상태</th>
                                                    <th>광고 지점</th>
                                                    <th>광고 상품</th>
                                                    <th>시작 기간</th>
                                                    <th>종료 기간</th>
                                                    <th>금액</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(adv, idx) in advList" :key="`adv_${idx}`" :class="{'fw-bold' : idx===0 || idx===1}">
                                                    <td>{{ adv.pk }}</td>
                                                    <td v-html="safeHTML(GET_AD_STATUS(adv.start_date, adv.end_date))"></td>
                                                    <td>{{ adv.name }} {{ adv.branch }}</td>
                                                    <td>{{ adv.adv_name }}</td>
                                                    <td>{{ adv.start_date }}</td>
                                                    <td>{{ adv.end_date }}</td>
                                                    <td>{{ adv.amount }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <UserInfoEditModal :userInfo="userInfo" :receive="receive" :errMsg="errMsg" @edit-parent-userInfo="editParentUserInfo(userInfo)" />

    <PwChangeModal :errMsg="errMsg" />

    <InquiryConfirmModal @save-inquiry="saveInquiry" />

    <InquiryDeleteConfirmModal @del-inquiry="delInquiry" />
</div>
</template>

<script>
import {
    DATE_FORMAT,
    GET_AD_STATUS
} from "@/config/date.js";
import common from "@/mixins/common.js";
import UserInfoEditModal from "@/components/modal/UserInfoEdit";
import PwChangeModal from "@/components/modal/PwChange";
import InquiryConfirmModal from "@/components/modal/InquiryConfirm";
import InquiryDeleteConfirmModal from "@/components/modal/InquiryDeleteConfirm";

export default {
    mixins: [common],
    components: {
        UserInfoEditModal,
        PwChangeModal,
        InquiryConfirmModal,
        InquiryDeleteConfirmModal
    },
    data() {
        return {
            loading: true,

            GET_AD_STATUS: GET_AD_STATUS,

            parentUserInfo: {
                name: this.$store.state.userInfo.name,
                phone_no: "",
                image_url: this.$store.state.defaultImageUrl
            },

            receive: {
                phone_no: "", // 사용자가 인증 시점에 입력한 휴대폰 번호
                verify_number: null // 사용자가 실제로 받는 인증번호 4자리
            },

            userInfo: {},

            errMsg: {
                email: "",
                name: "",
                phone_no: "",
                verify_number: "",

                current_password: "",
                new_password: "",
                new_password_confirm: ""
            },

            target_inquiry_pk: "",

            inquiry: {
                title: "",
                content: "",
                attachments: []
            },

            inquiryList: [],

            advList: [{
                    pk: 1,
                    name: "휴식",
                    branch: "광운대점",
                    adv_name: "PROFESSIONAL PACK",
                    start_date: "2024-08-01",
                    end_date: "2024-08-31",
                    amount: "50,000"
                },
                {
                    pk: 2,
                    name: "휴식",
                    branch: "광운대점",
                    adv_name: "ENTERPRISE PACK",
                    start_date: "2024-07-01",
                    end_date: "2024-07-31",
                    amount: "50,000"
                }, {
                    pk: 3,
                    name: "휴식",
                    branch: "명동점",
                    adv_name: "BUSINESS PACK",
                    start_date: "2024-06-01",
                    end_date: "2024-06-30",
                    amount: "50,000"
                }, {
                    pk: 4,
                    name: "휴식",
                    branch: "서울대벤처타운점",
                    adv_name: "PROFESSIONAL PACK",
                    start_date: "2024-05-01",
                    end_date: "2024-05-31",
                    amount: "50,000"
                },
                {
                    pk: 5,
                    name: "휴식",
                    branch: "노원 2호점",
                    adv_name: "ENTERPRISE PACK",
                    start_date: "2024-01-01",
                    end_date: "2024-01-31",
                    amount: "50,000"
                }, {
                    pk: 6,
                    name: "휴식",
                    branch: "노원 1호점",
                    adv_name: "BUSINESS PACK",
                    start_date: "2024-01-01",
                    end_date: "2024-01-31",
                    amount: "50,000"
                }
            ]
        }
    },
    beforeRouteLeave(to, from, next) {
        $(".modal").modal("hide");
        next();
    },
    async mounted() {
        try {
            const user_res = await this.axios.get("/user");

            this.parentUserInfo = user_res.data.result;
            this.parentUserInfo.image_url = this.parentUserInfo.image_url || this.$store.state.defaultImageUrl;
            this.receive.phone_no = this.parentUserInfo.phone_no;

            const inquiry_res = await this.axios.get("/inquiry");
            this.inquiryList = inquiry_res.data.result;

            this.inquiryList.forEach(inquiry => {
                inquiry.attachments = JSON.parse(inquiry.attachments);
                inquiry.created = DATE_FORMAT(inquiry.created, "long");

                if (inquiry.answer) {
                    inquiry.answer.created = DATE_FORMAT(inquiry.answer.created, "long");
                }
            });
        } catch (error) {
            console.log(error);
        } finally {
            this.loading = false;
        }
    },
    methods: {
        openModal(id) {
            this.userInfo = {
                ...this.parentUserInfo
            };
            $(`#${id}`).modal("show");
        },
        editParentUserInfo(userInfo) {
            this.parentUserInfo = {
                ...userInfo
            };
            this.$store.commit("SET_USERINFO", this.parentUserInfo);
        },
        openUpload() {
            document.getElementById("inquiryImg").click();
        },
        async selectImage(event) {

            const files = event.target.files;
            const sendData = new FormData();
            const totalCnt = files.length + this.inquiry.attachments.length; // 현재 파일 사진 수 + 이미 업로드 된 사진 수

            if (!files || files.length === 0) {
                return;
            }

            if (totalCnt > 5) {
                alert("문의하기 사진은 최대 5장까지 사진 첨부가 가능합니다.");
                return;
            }

            for (let i = 0; i < files.length; i++) {
                if (!files[i].type.includes("image")) {
                    alert("유저 사진은 이미지 파일만 등록 가능합니다.");
                    return;
                }
                sendData.append("filedata", files[i]);
            }

            try {
                this.loadingOverlay(true);

                const result = await this.axios.post("/upload/tempUploadOriginal", sendData);
                result.data.forEach(url => {
                    this.inquiry.attachments.push({
                        image_url: url
                    });
                });
            } catch (error) {
                console.log(error);
                alert("이미지 업로드 중 예기치 못한 에러가 발생하였습니다.\n다시 시도해주세요.");
            } finally {
                this.loadingOverlay(false);
            }
        },
        deleteImage(idx) {
            if (confirm("해당 이미지를 삭제하시겠습니까?")) {
                this.inquiry.attachments.splice(idx, 1);
            }
        },
        computedInquiryStatusColor(inquiry) {
            return inquiry.answer ? "text-bg-success" : "text-bg-warning";
        },
        computedInquiryStatusIcon(inquiry) {
            return inquiry.answer ? "mdi-check-bold" : "mdi-timer-sand";
        },
        computedInquiryStatusTxt(inquiry) {
            return inquiry.answer ? "답변 완료" : "답변 대기";
        },
        openConfirmModal() {
            if (this.inquiry.title.trim() === "") {
                alert("문의 제목을 입력해주세요.");
                return;
            }

            if (this.inquiry.content.trim() === "") {
                alert("문의 내용을 입력해주세요.");
                return;
            }

            $("#register-confirm-modal").modal("show");
        },
        async saveInquiry() {
            try {
                this.loadingOverlay(true);

                await this.axios.post("/inquiry", {
                    ...this.inquiry,
                    attachments: JSON.stringify(this.inquiry.attachments)
                });
                alert("정상적으로 등록이 완료 되었습니다.\n문의 주신 내용을 신속하게 검토하여 답변드리겠습니다.\n감사합니다.");
            } catch (error) {
                console.log(error);
                alert("문의 등록 중 예기치 못한 에러가 발생하였습니다.\n다시 시도해주세요.");
            } finally {
                this.loadingOverlay(false);

                // 변경
                this.$router.go();
            }
        },
        openDelModal(inquiry) {
            this.target_inquiry_pk = inquiry.pk;
            $("#inquiry-delete-modal").modal("show");
        },
        async delInquiry() {
            try {
                this.loadingOverlay(true);

                await this.axios.delete(`/inquiry/${this.target_inquiry_pk}`);
                alert("정상적으로 삭제가 완료 되었습니다");
            } catch (error) {
                console.log(error);
                alert("문의 삭제 중 에러가 발생하였습니다.\n다시 시도해주세요.");
            } finally {
                this.loadingOverlay(false);
                this.$router.go();
            }
        }
    }
}
</script>

<style>
.image-container {
    position: relative;
    display: inline-block;
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.delete-button {
    background: white;
    border: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
}
</style>
